export default {
    pageTitle: "home"
 }